import { render } from "./InputBlock.vue?vue&type=template&id=70c800fb&scoped=true&ts=true"
import script from "./InputBlock.vue?vue&type=script&lang=ts"
export * from "./InputBlock.vue?vue&type=script&lang=ts"

import "./InputBlock.vue?vue&type=style&index=0&id=70c800fb&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70c800fb"]])

export default __exports__